// UploadUserModal.js
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { uploadCSVFile, uploadUsersAction } from '../../../redux/actions/userAction';
import errorToast from '../../toasts/errorToast';
import successToast from '../../toasts/successToast';

const UploadUserModal = ({ isOpen, onClose }) => {
    const [usersData, setUsersData] = useState([]);
    const dispatch = useDispatch();

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        dispatch(uploadCSVFile(file, onSuccess, onError));
    };

    const onSuccess = (data) => {
        setUsersData(data.data.data.usersData);
        successToast(data.data.message)
    };

    const onError = (error) => {
        errorToast(error.data.message);
    };

    const handleUpload = () => {
        dispatch(uploadUsersAction({ usersData }, onUploadSuccess, onError));
    };
    const onUploadSuccess = (data) => {
        onClose();
        successToast(data.data.message);
    };
    const handleDownloadDemo = () => {
        const demoFileUrl = 'https://storage.googleapis.com/rare-shadow-276706.appspot.com/Users%20Demo%20Csv.csv';
        const link = document.createElement('a');
        link.href = demoFileUrl;
        link.download = 'demo-format.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Modal show={isOpen} onHide={onClose} centered backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>Import Users</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column'>
                    <div className="d-flex align-items-center justify-content-between">
                        <label htmlFor="fileInput" className="form-label me-2">
                            Select CSV file
                        </label>
                        <Button variant="link" onClick={handleDownloadDemo}>
                            Download Sample Format
                        </Button>
                    </div>
                    <input
                        className='input-field mt-2'
                        type="file"
                        id="fileInput"
                        accept=".csv"
                        onChange={handleFileChange}
                    />
                    <p className="mt-2">This will upload the user data from the selected CSV file to the system.</p>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" disabled={usersData.length < 1} onClick={handleUpload}>
                    Upload
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UploadUserModal;
